import { defineTokens } from '@chakra-ui/react';

import { appColorsHex, brandScaleHex } from './foundation/colors';

const brand = Object.fromEntries(
  Object.entries(brandScaleHex).map(([step, hex]) => [step, { value: hex }])
);

const app = Object.fromEntries(
  Object.entries(appColorsHex).map(([key, value]) => [key, { value }])
);

/**
 * Design tokens merged with Chakra’s defaults via `createSystem(defaultConfig, config)`.
 * @see https://chakra-ui.com/docs/theming/overview#theme
 */
export const tokens = {
  fonts: defineTokens.fonts({
    heading: { value: 'Inter, sans-serif' },
    body: { value: 'Satoshi, sans-serif' },
  }),
  fontSizes: defineTokens.fontSizes({
    '3xl': { value: '32px' },
    '2xl': { value: '24px' },
    xl: { value: '20px' },
    lg: { value: '18px' },
    md: { value: '16px' },
    sm: { value: '14px' },
    xs: { value: '12px' },
    xxs: { value: '10px' },
  }),
  colors: defineTokens.colors({
    brand,
    ...app,
    primary: { value: brandScaleHex[500] },
    darkPrimary: { value: brandScaleHex[700] },
  }),
};
